<template>
  <div class="region-pkg-wrap">
    <div class="card-header">
      地区组 <span class="num-text">{{ dataList.length }}/100</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" :disabled="!!alreadyCampaignId" @click="newRegionPkg">新增</el-button>
        <span class="center-line"></span>
        <el-button type="text" :disabled="!!alreadyCampaignId" @click="showBatchModal">批量导入</el-button>
        <span class="center-line"></span>
        <el-button type="text" :disabled="!!alreadyCampaignId" @click="selectPkg">选择已有</el-button>
        <span class="center-line"></span>
        <el-button type="text" :disabled="!!alreadyCampaignId" @click="clearAll">清空</el-button>
      </div>
    </div>
    <div v-show="dataList.length > 0">
      <div class="card-list">
        <card-item
          v-for="(item, index) of dataList"
          :key="item.itemId"
          :dataSet="item"
          :title="'新建地区组' + (index + 1)"
          @edit="editItemPkg"
          @copy="copyItemPkg"
          @del="delItemPkg"
          :isCur="curEditId === item.itemId"
          :showDelete="dataList.length > 1"
        ></card-item>
      </div>

      <new-region-pkg ref="newRegionRef"></new-region-pkg>
    </div>
    <div v-show="dataList.length === 0" class="select-count">
      {{ dataList.length === 0 ? "暂无数据" : "请选择账户" }}
    </div>

    <checked-modal title="选择地区组" :tableConf="tableConf" ref="checkedModalRef" @selectOk="selectOk"></checked-modal>
    <el-dialog title="批量导入" :close-on-click-modal="false" :visible.sync="dialogVisible" width="700px" :append-to-body="true">
      <div class="modal-body">
        <el-input
          style="margin-top: 8px"
          resize="none"
          type="textarea"
          :rows="10"
          placeholder="每一行生成一个地区组，行内支持英文逗号区隔（仅支持定向地区，不支持排除地区）"
          v-model="batchArea"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchImport">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CardItem from "./components/cardItem.vue";
import CheckedModal from "./components/checkedModal.vue";
import { importGoogleGeo } from "@/api/promotion-google.js";
import NewRegionPkg from "./components/newRegionPkg.vue";
import { mapState } from "vuex";
export default {
  components: {
    CardItem,
    CheckedModal,
    NewRegionPkg,
  },
  data() {
    return {
      tableConf: [
        { title: "地区组名称", colName: "groupName" },
        { title: "创建时间", colName: "createTime" },
      ],
      dataList: [],
      curEditId: "", //当前编辑的数据id
      dialogVisible: false,
      batchArea: "",
    };
  },
  mounted() {
    this.newRegionPkg();
  },
  methods: {
    //编辑地区组
    editItemPkg(dataItem) {
      if (dataItem.itemId === this.curEditId) {
        return;
      } else {
        //编辑切换时只保存到itemcard， 新增复制删除时需要保存到store触发计算（最终的保存在点击预览是校验格式并保存）
        this.saveInItemcard(); //保存当前数据到itemcard后再切换
        this.curEditId = dataItem.itemId;
        this.$refs.newRegionRef.fillData(dataItem);
      }
    },
    copyItemPkg(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      this.saveInItemcard();
      let copyData = JSON.parse(
        //先保存数据后取最新数据
        JSON.stringify(this.dataList.find((item) => item.itemId === dataItem.itemId))
      );
      copyData.itemId = Math.random();
      copyData.geoName = copyData.geoName + "_复制";
      this.dataList.push(copyData);
      // this.curEditId = copyData.itemId;
      //保存到store
      this.saveInStore();
    },
    delItemPkg(dataItem) {
      let curIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(curIndex, 1);
      //保存到store
      this.saveInStore();
    },
    showBatchModal() {
      this.batchArea = "";
      this.dialogVisible = true;
    },
    // 批量导入
    batchImport() {
      importGoogleGeo(this.batchArea.split("\n").splice(0, 100)).then((res) => {
        if (res.data?.length > 0) {
          res.data.map((item) => {
            this.newRegionPkg(item);
            this.dialogVisible = false;
          });
        }
      });
    },
    // 清空
    clearAll() {
      this.dataList = [];
      this.saveInstore();
    },
    //新建地区组
    newRegionPkg(batchArr = []) {
      if (this.dataList.length >= 100) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        geoName: "新建地区组" + (this.dataList.length + 1),
        regionType: "UNLIMITED",
        geo: {
          exclude: [],
          include: [],
        },
        languageType: "UNLIMITED_LAN",
        languages: [],
        positiveGeoTargetType: "PRESENCE_OR_INTEREST",
        negativeGeoTargetType: "PRESENCE",
      };
      if (batchArr.length > 0) {
        this.$set(newItem.geo, "include", batchArr);
      }
      this.dataList.push(newItem);
      this.editItemPkg(newItem);
      this.saveInStore();
      if (!batchArr.length > 0) {
        //清除自定义媒体包已选数据
        this.$refs.newRegionRef.clearCustomCountryList();
      }
    },
    selectPkg() {
      this.$refs.checkedModalRef.showModal(1);
    },
    selectOk(data) {
      data.forEach((item) => {
        let selectItem = JSON.parse(item.data);
        selectItem.itemId = Math.random();
        this.dataList.push(selectItem);
      });
      this.saveInStore();
    },
    saveInItemcard() {
      //保存到itemCard
      let editData = this.$refs.newRegionRef.formatData();
      let curIndex = this.dataList.findIndex((item) => item.itemId === this.curEditId);
      if (curIndex !== -1) {
        editData.itemId = this.curEditId;
        this.dataList[curIndex] = editData;
      }
      //保存到store
      // this.saveInStore();
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveInItemcard(); //保存当前数据后再保存到store
      this.saveInStore();
    },
    saveInStore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList)).map((item) => {
        // delete item.itemId;
        return item;
      });
      this.$store.commit("set_ad_series_google", {
        targetings: copyData,
      });
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          this.saveData();
          resolve();
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      targetings: (state) => state.PromotionGoogle.draftCampaign.targetings,
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
    }),
  },
  watch: {
    targetings(value) {
      if (value) {
        this.dataList = value;
        if (value.length > 0) {
          //聚焦最后一个
          this.editItemPkg(value[value.length - 1]);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.region-pkg-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .btn-group {
      margin-left: auto;
      .center-line {
        border-left: 1px solid rgba(0, 0, 0, 0.25);
        margin: 0 20px;
      }
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
  .select-count {
    height: 300px;
    font-size: 20px;
    color: #818181;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
